// Owner selector on the submit/edit form. Only rendered for admins; lets a
// recipe be created for, or moved to, another account.

import { Form } from "react-bootstrap";

export type OwnerOption = { id: number; userName: string };

type OwnerInputProps = {
  value: number | null;
  accounts: OwnerOption[];
  /** Shown when the current owner isn't in `accounts` (e.g. the list failed to load). */
  currentName?: string;
  onChange: (id: number) => void;
};

const OwnerInput = ({ value, accounts, currentName, onChange }: OwnerInputProps) => {
  const known = value !== null && accounts.some((a) => a.id === value);
  return (
    <Form.Group controlId="recipe-owner">
      <Form.Label className="mb-1">Owner</Form.Label>
      <Form.Select
        name="creator_id"
        value={value ?? ""}
        onChange={(e: React.ChangeEvent<HTMLSelectElement>) => onChange(Number(e.target.value))}
      >
        {value !== null && !known && <option value={value}>{currentName || `account ${value}`}</option>}
        {accounts.map((a) => (
          <option key={a.id} value={a.id}>
            {a.userName}
          </option>
        ))}
      </Form.Select>
    </Form.Group>
  );
};

export default OwnerInput;
